<!-- Translated: no -->
<template>
  <Modal @close="localCloseModal" :wide="false" :show-close="canClose" width="550px">

    <!-- <div class="blocked center" v-if="$store.state.isOnSite">
      <p>{{ $t('skirental.welcome') }}</p>
      <hr />
      <p>&nbsp;</p>
    </div> -->

    <LanguageSwitcher type="dropdown" v-if="!$store.state.isOnSite" :show-title="true" />

    <div v-if="!SITE_CONFIG.modules_open.skiletting.open" class="rental-closed">
      <p>{{ SITE_CONFIG.modules_open.skiletting.closed_message }}</p>
    </div>

    <div v-if="SITE_CONFIG.modules_open.skiletting.open">
    <h1 v-if="params.type === 'without-delivery'">{{ $t('general.people-count-title') }}</h1>

    <div class="blocked info" v-if="guidedRentals.length">
      <b><icon name="info" :scale="1.4" />{{ $t('skipass.existing-booking-title') }}</b>
      <p>Du har en påbörjad bokning i varukorgen. Du kommer att radera den bokningen om du fortsätter. Klicka på <i>"Fortsätt tidigare bokning"</i> för att ändra den påbörjade bokningen istället.</p>
    </div>

    <div class="blocked center" v-if="guidedRentals.length">
      <button @click="goOn()" v-if="guidedRentals.length">{{ $t('skipass.existing-booking-continue') }} <icon name="arrow-white" :scale="1.2" /></button>
      <hr />
    </div>

    <div class="center">
      <h1 v-if="params.type === 'with-delivery' && accomodation" class="accomodation-title">{{accomodation.name}}</h1>
    </div>

    <div v-if="params.type === 'with-delivery'">

      <div v-if="!loggedIn && !accomodation">

        <div class="blocked info" style="margin-top:0;">
          <b><icon name="info" :scale="1.4" />{{ $t('skirental.find-accomodation') }}</b>
          <p>
            {{ $t('skirental.free-delivery-text', {clickhere: ''}) }} <router-link :to="{ name: 'accomodation list' }">{{ $t('general.clickhere') }}</router-link>.
          </p>
        </div>

        <Login @login="onLogin" />
      </div>

      <div v-if="loggedIn || accomodations.length">

        <AccomodationPeriodConfirm v-if="accomodation" :unit="unit" :arrival="arrival" :departure="departure" :small="true" :check-availability="false"></AccomodationPeriodConfirm>

        <div style="clear:both;"></div>

        <div class="blocked info" v-if="!accomodations.length && !loading">
          <b><icon name="info" :scale="1.4" />{{ $t('skirental.no-accomodation-title') }}</b>
          <p v-if="!foundNotAllowedDelivery">{{ $t('skirental.no-accomodation-text') }}</p>
          <p v-if="foundNotAllowedDelivery">Vi hittade inga boenden där utkörning är möjligt.</p>
        </div>

        <div class="blocked" v-if="accomodations.length > 1">
          <b>{{ $t('skirental.pick-accomodation') }}</b>
          <Dropdown
            :options="accomodationsToSelect"
            :valuebinder.sync="selectedAccomodation"
            :validated="accomodation"
            :label="!accomodation ? $t('skirental.pick-accomodation') : accomodation.name"
            :allow-empty="false"
            @changed="changedAccomodation"
            />
        </div>

        <p v-if="accomodations.length">&nbsp;</p>

        <div class="blocked info test" v-if="possibleWithStorage">
          <b><icon name="info" :scale="1.4" />Obs! Nattförvaring</b>
          <p>Istället för utkörning har ditt boende ett förvaringsbås i skiduthyrningen fem meter från åkbar snö. I ditt skidnära bås kan du förvara dina skor under dagen så att du kan gå i dina bekväma skor till och från ditt boende.</p>
          <p v-if="accomodations.length > 1">&nbsp;</p>
        </div>

        <div class="blocked info extra-info" v-if="!possibleWithDelivery">
          <b><icon name="info" :scale="1.4" />{{ $t('skirental.delivery.close-time-title') }}</b>
          <p>{{ $t('skirental.delivery.close-time-text-1') }}</p>
          <p><a href="#" @click.stop.prevent="openWithoutDelivery">{{ $t('general.clickhere') }}</a> {{ $t('skirental.delivery.close-time-text-2', {clickhere: ''}) }}</p>
        </div>

      </div>

    </div>

    <Loading :show="loading" />

    <div class="blocked center" v-if="params.type === 'without-delivery' || (accomodation && possibleWithDelivery)">
      <b class="uppercase block">{{ $t('general.people-count') }}</b>
      <CounterButton ref="counterButton" class="counter-button" :inline="true" :count="peopleCount" :min="1" @changedCount="changePeople($event)" :suffix="' ' + $t('general.pieces-short')" />
    </div>

    <div class="blocked center" v-if="params.type === 'without-delivery' || (accomodation && possibleWithDelivery)">
      <button @click="startBooking()" :disabled="!validate()">{{ $t('general.cta.begin-booking') }} <icon name="arrow-white" :scale="1.2" /></button>
    </div>

    <!-- <div class="blocked info" v-if="params.type === 'without-delivery' && SITE_CONFIG.modules.accomodation">
      <b><icon name="info" :scale="1.4" />{{ $t('skirental.delivery.whole-time-title') }}</b>
      <p v-if="SITE_CONFIG.site === 'branas'">{{ $t('skirental.delivery.whole-time-text-branas') }}</p>
      <p v-else>{{ $t('skirental.delivery.whole-time-text') }}</p>
    </div> -->

    <div class="blocked info" v-if="params.type === 'with-delivery'">
      <b><icon name="info" :scale="1.4" />{{ $t('skirental.delivery.time-title') }}</b>
      <p>{{ $t('skirental.delivery.time-text') }}</p>
    </div>

    <div class="blocked info" v-if="SITE_CONFIG.modules.accomodation && !$store.state.isOnSite">
      <b v-if="params.type === 'without-delivery'"><icon name="info" :scale="1.4" />{{$t('skirental.delivery.delivery')}}</b>
      <b v-if="params.type === 'with-delivery'"><icon name="info" :scale="1.4" />{{$t('skirental.delivery.pickup')}}</b>
      <p v-if="params.type === 'without-delivery'">{{$t('skirental.delivery.delivery-text')}} <a href="#" @click.stop.prevent="openWithDelivery">{{$t('skirental.delivery.click-here')}}</a></p>
      <p v-if="params.type === 'with-delivery'">{{$t('skirental.delivery.pickup-text')}} <a href="#" @click.stop.prevent="openWithoutDelivery">{{$t('skirental.delivery.click-here')}}</a></p>
    </div>

    </div>

  </Modal>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex';
import Modal from '@/components/components/Modal';
import CounterButton from '@/components/components/CounterButton';
import Dropdown from '@/components/components/Dropdown';
import Login from '@/components/payments/Login';
import Loading from '@/components/components/Loading';
import AccomodationCartItem from '@/classes/AccomodationCartItem';
import API from '@/classes/API';
import AccomodationPeriodConfirm from '@/components/parts/Accomodation/AccomodationPeriodConfirm';
import {
  validStartDate,
} from '@/dates';

import LanguageSwitcher from '@/components/components/LanguageSwitcher';

import moment from 'moment';

export default {
  props: {
    params: {},
  },
  components: {
    Modal,
    CounterButton,
    Dropdown,
    AccomodationPeriodConfirm,
    Login,
    Loading,
    LanguageSwitcher,
  },
  data() {
    return {
      peopleCount: 1,
      accomodation: null,
      unit: {},
      arrival: '',
      departure: '',
      accomodations: [],
      foundNotAllowedDelivery: false,
      loading: false,
      selectedAccomodation: null,
      possibleWithStorage: false,
    };
  },
  async mounted() {
    await this.reload();
  },
  computed: {
    canClose() {
      return !this.$store.state.isOnSite;
    },
    validStartDate() {
      return validStartDate({
        validStartDates: this.validStartDates,
      });
    },
    accomodationsToSelect() {
      const val = [];
      this.accomodations.forEach((accomodation, index) => {
        const arrival = moment(accomodation.arrival || accomodation.period.date_arrival).format('D[/]M');
        const departure = moment(accomodation.departure || accomodation.period.date_departure).format('D[/]M');
        val.push({
          value: index,
          title: (accomodation.unit ?
            (accomodation.unit.display_name
              || accomodation.unit.description_title) : accomodation.name),
          subtitle: `${arrival} - ${departure}`,
        });
      });
      return val;
    },
    possibleWithDelivery() {
      const tz = moment.tz.guess(true);

      const arrival = moment.tz(this.arrival, 'Europe/Stockholm');
      const now = moment.tz(moment(), tz);
      const diff = arrival.diff(now, 'hours', true);

      if (this.SITE_CONFIG.site === 'branas') {
        if (diff <= 12) {
          return false;
        }
        return true;
      }

      if (diff < (2 * 24)) {
        return false;
      }
      return true;
    },
    ...mapGetters([
      'loggedIn',
      'guidedRentals',
    ]),
  },
  methods: {
    ...mapMutations([
      'closeModal',
      'closeAllModals',
      'openModal',
      'addRentalPeople',
      'confirmedAccomodations',
    ]),
    async reload() {
      console.log('...reloading');
      const accomodations = JSON.parse(JSON.stringify(this.$store.state.cart.accomodations));
      const confirmed = accomodations.filter(accomodation => accomodation.confirmed);

      if (confirmed.length) {
        this.accomodation = confirmed[0];
        this.accomodations = confirmed;
        this.unit = {
          pool_lid: this.accomodation.poolLid,
          unit_lid: this.accomodation.unitLid,
          name: this.accomodation.name,
        };
        this.arrival = this.accomodation.period.date_arrival;
        this.departure = this.accomodation.period.date_departure;

        this.$nextTick(() => {
          // Set people count
          this.peopleCount = AccomodationCartItem.peopleCount(confirmed[0]);
          if (this.$refs.counterButton) {
            this.$refs.counterButton.count = this.peopleCount;
          }
        });
      } else if (this.loggedIn && this.params.type === 'with-delivery') {
        await this.getAccomodations();
      }

      if (this.guidedRentals.length) {
        if (!this.$store.state.cart.addToOrder || !this.$store.state.cart.addToOrder.number) {
          this.closeModal();
          this.$router.push({ name: 'ski rental overview' });
        }
      }

      if (this.accomodation) {
        this.paramsType = 'with-delivery';

        const { success } = await API.get(`equipment-storage-available/${this.accomodation.poolLid}/${this.accomodation.unitLid}`);
        this.possibleWithStorage = success;
      }
    },
    async getAccomodations() {
      this.loading = true;
      if (this.SITE_CONFIG.site === 'branas' || this.SITE_CONFIG.site === 'kungsberget') {
        let url = 'orders/accomodations';
        if (this.$store.state.cart.addToOrder && this.$store.state.cart.addToOrder.numeric) {
          url = `${url}/${this.$store.state.cart.addToOrder.numeric}`;
        }

        const { data, hasNotAllowed } = await API.get(url);
        this.accomodations = data;
        this.foundNotAllowedDelivery = hasNotAllowed;
      }
      if (this.accomodations.length) {
        this.selectAccomodation(0);
      }
      this.loading = false;
    },
    selectAccomodation(index) {
      this.accomodation = Object.assign({}, this.accomodations[index]);
      this.accomodation.name = (this.accomodation.unit ?
        (this.accomodation.unit.display_name
          || this.accomodation.unit.description_title) : this.accomodation.name);
      this.unit = {
        pool_lid: (this.accomodation.unit
          ? this.accomodation.unit.pool_lid : this.accomodation.poolLid),
        unit_lid: (this.accomodation.unit
          ? this.accomodation.unit.unit_lid : this.accomodation.unitLid),
        name: (this.accomodation.unit
          ? this.accomodation.unit.display_name : this.accomodation.display_name),
      };

      this.arrival = (this.accomodation.period
        ? this.accomodation.period.date_arrival : this.accomodation.arrival);
      this.departure = (this.accomodation.period
        ? this.accomodation.period.date_departure : this.accomodation.departure);
    },
    changedAccomodation(v) {
      this.selectAccomodation(v.value);
    },
    onLogin() {
      this.params.type = 'with-delivery';
      this.reload();
    },
    localCloseModal() {
      this.$router.push({ name: 'shopping cart' });
    },
    validate() {
      let errors = 0;
      errors += (this.peopleCount ? 0 : 1);
      errors += (this.params.type === 'with-delivery' && !this.accomodation ? 1 : 0);
      errors += (this.params.type === 'with-delivery' && !this.possibleWithDelivery ? 1 : 0);
      return !errors;
    },
    changePeople(payload) {
      // return payload;
      this.peopleCount = payload;
      // this.pickAccomodation(payload);
      // this.closeAllModals();
      // this.$router.push({ name: 'confirm-accomodation' });
    },
    startBooking() {
      let date = null;
      let days = null;

      if (this.$store.state.cart.addToOrder && this.$store.state.cart.addToOrder.dateStart) {
        date = this.$store.state.cart.addToOrder.dateStart;
        days = Math.round(moment(this.$store.state.cart.addToOrder.dateEnd).diff(
          this.$store.state.cart.addToOrder.dateStart) / 60 / 60 / 24 / 1000) + 1;
      } else if (this.params.type === 'with-delivery') {
        if (this.accomodation.arrival) {
          date = this.accomodation.arrival;
          days = Math.round(moment(this.accomodation.departure).diff(
            this.accomodation.arrival) / 60 / 60 / 24 / 1000) + 1;
        } else {
          date = this.accomodation.period.date_arrival;
          days = Math.round(moment(this.accomodation.period.date_departure).diff(
            this.accomodation.period.date_arrival) / 60 / 60 / 24 / 1000) + 1;
        }
      }

      this.addRentalPeople({
        peopleCount: this.peopleCount,
        pickedStartDate: date,
        numberOfDays: days,
        delivery: (this.params.type === 'with-delivery'),
        deliveryTo: this.unit,
        append: false,
      });

      if (date) {
        this.$store.state.cart.rentalDateRestriction = {
          date,
          days,
        };
      } else {
        this.$store.state.cart.rentalDateRestriction = {};
      }

      if (this.params.type === 'with-delivery' && this.accomodation && this.accomodation.order) {
        this.$store.state.cart.addToOrder = {
          number: this.accomodation.order.number,
          numeric: this.accomodation.order.ext_r360_id,
        };
      }

      this.closeAllModals();

      this.$router.push({ path: '/skidhyra/0' });
    },
    goOn() {
      this.closeModal();
      this.$router.push({ path: '/skidhyra/oversikt' });
    },
    openWithoutDelivery() {
      this.params.type = 'without-delivery';
      this.accomodations = [];
      this.reload();
    },
    openWithDelivery() {
      this.params.type = 'with-delivery';
      this.reload();
    },
  },
};
</script>

<style scoped lang="stylus">
@import '~@/global.styl'


button
  font-size: 13px
  margin-top: 10px
  .icon
    margin-left: 5px
    position: relative
    top -1px

h1.accomodation-title
  font-size 19px
  font-weight bold
  text-align center
  color #262626
  text-transform none
  border-radius 2px
  background-color #ecf5f8
  border solid 1px #bfd9e1
  padding 7px 20px
  display inline-block

.uppercase
  font-size: 11px
  margin-bottom: 10px

.blocked
  margin-bottom space-2
  width:344px;
  max-width:100%;
  margin-left: auto;
  margin-right: auto;


.info
  border-radius 2px
  background-color rgba(199, 220, 183, 0.26)
  border solid 1px #d1e0c2
  padding 15px 27px
  margin-top: 30px
  &.extra-info
    background-color: #fff4d7
    border: 1px solid #ffe67d
  b
    font-size 11px
    font-weight bold
    color #1c1c1c
    display block
    margin-bottom 5px
    uppercase()
    .icon
      margin-right 3px
      position relative
      top -1px
  p
    font-size 14px
    font-weight 300
    line-height 1.3
    color #262626
    margin 0
  &.small
    padding 10px 8px
    p
      font-size 11px
      color #1c1c1c

select
  height 45px
  border-radius 4px
  background-color #ffffff
  border solid 2px #bfd9e1
  width 100%

hr
  border-top solid 2px #bfd9e1
  margin-top space-3

.rental-closed
  text-align center
  margin 4em auto
  max-width 650px
  font-size 16px
  line-height 1.5
  padding 0 20px
</style>



// WEBPACK FOOTER //
// SkiRentalPickDate.vue?20ab3096